import Vue from "vue";
import App from "./App.vue";
import VueResource from "vue-resource";
import "./quasar";
import router from "./router";
import Notifications from "vue-notification";
import store from "./store";
import Vuex from "vuex";
import i18n from "./i18n";
import VueCurrencyInput from "vue-currency-input";
import VueCookies from "vue-cookies";
import utils from "./shared/utils";

Vue.use(VueResource);

Vue.use(Notifications);
Vue.use(Vuex);
Vue.use(VueCurrencyInput);
Vue.use(VueCookies);

Vue.config.productionTip = false;
Vue.prototype.$utils = utils;

const app = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");


window.App = app;